import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FullScreen from '@blade/common/components/full-screen.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import InputSearch from '@blade-sxp/record-center/components/input-search.vue';
import FaceControl from '@blade-sxp/record-center/components/face-control.vue';
import CarPage from '@blade-sxp/record-center/components/car-page.vue';
import typo from '@blade-sxp/record-center/lang/index';
import { Result, Scene } from '@blade-sxp/record-center/interfaces';
import { exportRecord, getRecord } from '@blade-sxp/record-center/api/portrait';
import ExportButton from '@blade-sxp/record-center/components/buttons/export-button.vue';
import moment from 'moment';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import { getPreDaysParamsIncludeToday } from '@blade-sxp/record-center/utils/date-util';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
import DatePicker from '@blade/common/components/date-time-select/index.vue';
import AttendanceRecord from '@blade-sxp/record-center/components/attendance-record/index.vue';
import LibPortaitSearchItem from '@blade-sxp/record-center/components/search-items/portait-libray.vue';
import DeviceTreeSearchItem from '@blade-sxp/record-center/components/search-items/device-tree.vue';
let default_1 = class extends Vue {
    fullSkDialogVisible = false;
    // exportLoading: boolean = false;
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    defaultTime = ['00:00:00', '23:59:59'];
    permissionlevel = permissionlevel;
    initialForm = {
        dates: this.getDafaultDates(),
        result: '',
        keyword: '',
        comments: '',
        recognitionTypes: '',
        libIds: [],
        deviceIds: [],
    };
    tableData = [];
    dialogVisible = false;
    form = { ...this.initialForm };
    activeTab = 'attendance ';
    ages = [];
    genders = [];
    exportMode = 'TEXT';
    uploadFullMsg = null;
    get sceneOptions() {
        return [
            {
                value: Scene.PASS,
                label: this.$t('PASS'),
            },
            {
                value: Scene.ATTENDANCE,
                label: this.$t('ATTENDANCE'),
            },
            {
                value: Scene.PAYMENT,
                label: this.$t('PAYMENT'),
            },
        ];
    }
    get resultOptions() {
        return [
            {
                value: Result.SUCCESS,
                label: this.$t('success'),
            },
            {
                value: Result.FAILURE,
                label: this.$t('fail'),
            },
        ];
    }
    get commentList() {
        return [
            {
                value: 'REMARK_CONFIRM_MATCH',
                label: this.$t('confirmMatched'),
            },
            {
                value: 'REMARK_IDENTIFICATION_ERROR',
                label: this.$t('confirmUnmatched'),
            },
            {
                value: 'REMARK_BLANK',
                label: '-',
            },
        ];
    }
    get recognitionMethodList() {
        return [
            {
                value: 'FACE',
                label: this.$t('face'),
            },
            {
                value: 'IC_CARD',
                label: this.$t('card'),
            },
            {
                value: 'FACE_AND_IC_CARD',
                label: this.$t('faceAndCard'),
            },
            {
                value: 'QR_CODE',
                label: this.$t('qrCode'),
            },
        ];
    }
    page = 1;
    size = 10;
    total = 0;
    isLoading = false;
    handleCommand(type) {
        this.exportMode = type;
        this.handleDialog();
    }
    initUploadFullWebsocket(url) {
        this.uploadFullMsg = new AlarmWebsocket(url);
        this.uploadFullMsg.setOnMessage((e) => {
            let msg;
            try {
                msg = JSON.parse(e.data);
            }
            catch (_) {
                msg = e.data;
            }
            this.dispatchUpload(msg);
        });
    }
    dispatchUpload(msg) {
        if (msg?.businessType === 'FACE_COMPARISON_RECORD_EXPORT') {
            if (msg?.handlerStatus === 'FINISH') {
                this.isLoading = false;
                window.location.href = msg.fileUrl;
                this.uploadFullMsg?.close();
            }
            if (msg?.handlerStatus === 'ERROR') {
                this.$message({
                    message: msg.message,
                    type: 'error',
                });
                this.uploadFullMsg?.close();
            }
        }
    }
    async search() {
        this.isLoading = true;
        const [dateStart, dateEnd] = this.form.dates || [];
        const { keyword, result, comments, recognitionTypes, libIds, deviceIds } = this.form;
        console.log('search form', this.form);
        try {
            const res = await getRecord({
                dateStart: dateStart ? `${dateStart}` : '',
                dateEnd: dateEnd ? `${dateEnd}` : '',
                status: result,
                keyword,
                page: this.page,
                size: this.size,
                ages: this.ages,
                genders: this.genders,
                comments: comments ? [comments] : [],
                recognitionTypes: recognitionTypes ? [recognitionTypes] : [],
                libIds,
                deviceIds,
            });
            const { list, total } = res;
            this.tableData = list;
            this.total = total;
        }
        catch (e) {
            // this.tableData = [];
            // this.$message.error(String(e));
        }
        finally {
            this.isLoading = false;
        }
    }
    mounted() {
        this.search();
    }
    filterAge(val) {
        this.ages = val;
        this.search();
    }
    filterGender(val) {
        this.genders = val;
        this.search();
    }
    getDafaultDates() {
        const { dateStart, dateEnd } = getPreDaysParamsIncludeToday(false, 2);
        return [`${dateStart} 00:00:00`, `${dateEnd} 23:59:59`];
    }
    reset() {
        this.form = { ...this.initialForm };
        // this.form.dates = ['', ''];
    }
    onSearch() {
        this.page = 1;
        this.dialogVisible = false;
        this.search();
    }
    async onExport() {
        const [dateStart, dateEnd] = this.form.dates || [];
        const { keyword, result } = this.form;
        return exportRecord({
            dateStart,
            dateEnd,
            status: result,
            keyword,
            page: this.page,
            size: this.size,
        });
    }
    handleDialog() {
        this.fullSkDialogVisible = true;
    }
    handleExport() {
        const [dateStart, dateEnd] = this.form.dates || [];
        const { keyword, result, comments, recognitionTypes, libIds, deviceIds } = this.form;
        const params = {
            exportMode: this.exportMode,
            dateStart: dateStart ? `${dateStart}` : '',
            dateEnd: dateEnd ? `${dateEnd}` : '',
            status: result,
            keyword,
            comments: comments ? [comments] : [],
            recognitionTypes: recognitionTypes ? [recognitionTypes] : [],
            libIds,
            deviceIds,
        };
        // this.exportLoading = true;
        try {
            exportRecord(params)
                .then((res) => {
                if (res) {
                    if (this.exportMode === 'TEXT') {
                        window.location.href = process.env.NODE_ENV === 'development' ? `${res}` : res;
                    }
                    else {
                        const wsRealTimeUrl = process.env.NODE_ENV === 'development'
                            ? process.env.VUE_APP_UPLOAD_WS
                            : `wss://${window.location.host}/${process.env.VUE_APP_UPLOAD_WS}`;
                        this.initUploadFullWebsocket(wsRealTimeUrl);
                        this.isLoading = true;
                    }
                }
                else {
                    // this.exportLoading = false;
                }
            })
                .finally(() => {
                // this.exportLoading = false;
            });
        }
        catch (error) {
            console.log('handleExport err');
            // this.exportLoading = false;
        }
    }
    handleSizeChange(size) {
        this.page = 1;
        this.size = size;
        this.search();
    }
    handleCurrentChange(page) {
        this.page = page;
        this.search();
    }
    pickerOptions = {
        disabledDate: (date) => moment(date).add(-1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')),
    };
    // tabs 的切换
    handleClick(tab, event) {
        // console.log(tab, event);
        this.activeTab = tab.name;
    }
    getScreenNum() {
        let num = 0;
        const form = this.form;
        Object.keys(form).forEach((k) => {
            const val = form[k];
            if (k !== 'keyword') {
                // keyword 不計入
                if (val instanceof Array) {
                    val.length > 0 && num++;
                }
                else {
                    val && num++;
                }
            }
        });
        return num;
    }
    beforeDestroy() {
        this.uploadFullMsg?.close();
    }
};
default_1 = __decorate([
    Component({
        name: 'record',
        components: {
            FaceControl,
            CarPage,
            FullScreen,
            AuthItem,
            ExportButton,
            AuthNewitem,
            SecondaryVerification,
            InputSearch,
            DatePicker,
            AttendanceRecord,
            LibPortaitSearchItem,
            DeviceTreeSearchItem,
        },
        i18n: {
            messages: {
                'en-us': {
                    timeRanges: 'Time',
                    keyword: 'Keyword',
                    reset: 'Reset',
                    Inquire: 'Search',
                    faceControl: 'Watchlist Monitoring',
                    crowdControl: 'Crowd Control',
                    crowdStatistics: 'Crowd statistics',
                    name: 'Name',
                    keywordPlaceholder: 'Name/IC Card/Device/Serial-number',
                    deviceName: 'Device Name',
                    area: 'area',
                    missionName: 'Task Name',
                    deploymentStrategy: 'Control Policy',
                    deviceType: 'Device type',
                    pleaseSelect: 'Please select the data to be exported',
                    sense: 'Scene',
                    status: 'Status',
                    success: 'Success',
                    fail: 'Fail',
                    faceRecognitionRecord: 'Personnel Recognition Record',
                    vehiclePassingRecord: 'Vehicle Passing Record',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                    total: 'Total {msg} Items',
                    attendanceRecord: 'Attendance  Record',
                    qrCode: 'Pass Code',
                },
                zh: {
                    timeRanges: '时间范围',
                    reset: '重置',
                    keyword: '关键词',
                    Inquire: '搜索',
                    crowdStatistics: '人群统计',
                    name: '姓名',
                    keywordPlaceholder: '输入姓名/IC卡/设备名称/设备序列号',
                    deviceName: '设备名称',
                    area: '区域',
                    missionName: '任务名称',
                    deploymentStrategy: '布控策略',
                    deviceType: '设备类型',
                    pleaseSelect: '请选择需要导出的数据',
                    sense: '识别场景',
                    status: '识别结果',
                    success: '识别成功',
                    fail: '识别失败',
                    faceRecognitionRecord: '人员识别记录',
                    vehiclePassingRecord: '车辆通行记录',
                    cancel: '取消',
                    confirm: '确认',
                    total: '总共 {msg} 条',
                    attendanceRecord: '考勤记录',
                    qrCode: '通行码',
                },
            },
            sharedMessages: typo.messages,
        },
    })
], default_1);
export default default_1;
